/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import root from "assets/theme/theme-dark/elements/button/root";
import contained from "assets/theme/theme-dark/elements/button/contained";
import outlined from "assets/theme/theme-dark/elements/button/outlined";
import buttonText from "assets/theme/theme-dark/elements/button/text";

const button = {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    root: { ...root },
    contained: { ...contained.base },
    containedSizeSmall: { ...contained.small },
    containedSizeLarge: { ...contained.large },
    containedPrimary: { ...contained.primary },
    containedSecondary: { ...contained.secondary },
    outlined: { ...outlined.base },
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    outlinedPrimary: { ...outlined.primary },
    outlinedSecondary: { ...outlined.secondary },
    text: { ...buttonText.base },
    textSizeSmall: { ...buttonText.small },
    textSizeLarge: { ...buttonText.large },
    textPrimary: { ...buttonText.primary },
    textSecondary: { ...buttonText.secondary },
  },
};

export default button;
